import { AfterContentInit, Component, ElementRef, Input, OnInit, NgModule, ViewChild } from '@angular/core';
import { FormArray, FormControl, FormGroup, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { GenericdatasetService } from '../../services/genericdataset/genericdataset.service';
import { Observable } from 'rxjs/Observable';

import { Error } from './error';

import { StepsRoutingModule } from './steps.routing.module';

import { GenericListModalService } from '../../services/genericlistmodal/genericlistmodal.service';
import { ReactiveformComponent } from '../reactiveform/reactiveform.component';

declare const $: any;
declare const toastr: any;

@Component({
  selector: 'steps',
  template: `
  <div *ngIf="visible" style="overflow: auto;">
    <div *ngIf="!loading" class="steps-form-2">
        <div class="steps-row-2" style="display: block; text-align: -webkit-center;">
            <div *ngFor="let step of stepList; let i = index" class="steps-step-2" (click)="selectStep(step,i)">
                <a type="button" class="btn btn-circle-2 waves-effect" [ngClass]="{'valid': step.valid,'warning':!step.index && !step.valid,'select': step == selectedStep}"
                    data-toggle="tooltip" data-placement="top" title="{{step.name}}">
                    <i class="fa {{step.glyph}}" aria-hidden="true"></i>
                </a>
            </div>
            <div *ngIf="selectedStep && !selectedStep.valid" class="steps-step-2 pl-3" (click)="valid()">
                <a type="button" class="btn btn-circle-2 add waves-effect" data-toggle="tooltip" data-placement="top" title="Validé">
                    <i class="fa fa fa-check" aria-hidden="true"></i>
                </a>
            </div>
            <div class="steps-step-2" (click)="openModalList()">
                <a type="button" class="btn btn-circle-2 add waves-effect" data-toggle="tooltip" data-placement="top" title="Ajouter">
                    <i class="fa fa-plus" aria-hidden="true"></i>
                </a>
            </div>
        </div>
    </div>
    <span *ngIf="error" class="help-block text-danger" style="font-size: 15px">
        <b>{{ error }}</b>
    </span>
  </div>`,
  styles: [`
  .steps-form-2 {
    display: table;
    width: 100%;
    position: relative;
  }
  
  .steps-form-2 .steps-row-2 {
    display: table-row;
  }
  
  .steps-form-2 .steps-row-2:before {
    top: 14 px;
    bottom: 0;
    position: absolute;
    content: " ";
    width: 100px;
    height: 2px;
  }
  
  .steps-form-2 .steps-row-2 .steps-step-2 {
    display: table-cell;
    text-align: center;
    position: relative;
  }
  
  .steps-form-2 .steps-row-2 .steps-step-2 p {
    margin-top: 0.5rem;
  }
  
  .steps-form-2 .steps-row-2 .steps-step-2 button[disabled] {
    opacity: 1!important;
    filter: alpha(opacity=100)!important;
  }
  
  .steps-form-2 .steps-row-2 .steps-step-2 .btn-circle-2 {
    width: 45px;
    height: 45px;
    background-color: #007bff!important;
    border-radius: 50%;
    padding: 14px 12px 16px 10px;
    margin-top: 2px;
  }
  
  .steps-form-2 .steps-row-2 .steps-step-2 .btn-circle-2.select {
    border: 2px solid grey !important ;
  }
  
  .steps-form-2 .steps-row-2 .steps-step-2 .btn-circle-2.valid {
    background-color: #00C851 !important;
  }
  
  .steps-form-2 .steps-row-2 .steps-step-2 .btn-circle-2.default {
    background-color: #2BBBAD !important;
  }
  
  .steps-form-2 .steps-row-2 .steps-step-2 .btn-circle-2.danger {
    background-color: #CC0000 !important;
    border: 2px solid #CC0000;
  }
  
  .steps-form-2 .steps-row-2 .steps-step-2 .btn-circle-2.warning {
    background-color: #F80 !important;
    border: 2px solid #F80;
  }
  
  .steps-form-2 .steps-row-2 .steps-step-2 .btn-circle-2.secondary {
    background-color: #2BBBAD !important;
    border: 2px solid #2BBBAD;
  }
  
  .steps-form-2 .steps-row-2 .steps-step-2 .btn-circle-2.success {
    background-color: #00C851 !important;
    border: 2px solid #00C851;
  }
  
  .steps-form-2 .steps-row-2 .steps-step-2 .btn-circle-2.add {
    border: 2px solid rgba(0, 0, 0, 0.54) !important;
    background-color: white!important;
    color: rgba(0, 0, 0, 0.54) !important;
  }
  
  .steps-form-2 .steps-row-2 .steps-step-2 .btn-circle-2:hover {
    border: 2px solid #01579b;
    color: #01579b!important;
    background-color: white!important;
  }
  
  .steps-form-2 .steps-row-2 .steps-step-2 .btn-circle-2 .fa {
    font-size: 1.2rem;
  }`]
})

export class StepsComponent {
  @ViewChild('steps') steps: ElementRef;
  @Input() public name: string = '';
  @Input() public caption: string = '';
  @Input() public length: string = '0';
  @Input() public visible: boolean = true;
  @Input() public enabled: Boolean = false;
  @Input() public value: any;
  @Input() public glyph: string = '';
  @Input() public error: any;
  @Input() public _parentId: number;
  @Input() public parentFieldName: string = '';
  @Input() public parentName: string = '';
  @Input() public historicName: string = '';
  @Input() public modalName: string = '';
  @Input() public uid: number;
  @Input() public isSole: boolean = true;
  @Input() public reactiveForm: ReactiveformComponent;
  public modalId: number;
  protected dbform_id: number;
  public loading: boolean = false;
  public selectedStep: any = null;
  public stepList: any[] = [];
  public lastIndex: number = 0;

  constructor(public genericlistService: GenericListModalService, public itemService: GenericdatasetService) {
  }

  @Input() public set parentId(parentId: number) {
    this._parentId = parentId;
    if (parentId) this.load();
  }

  public get parentId(): number {
    return this._parentId;
  }

  load() {
    if (!(this.dbform_id > 111)) {
      this.itemService.getUrl('dbforms?filter[where][uid]=' + this.uid)
        .subscribe(
        (dbform) => {
          if (dbform != null) {
            this.dbform_id = dbform[0].id;
            this.loadData();
          }
        });
    } else {
      this.loadData();
    }
  }

  loadData() {
    this.stepList = [];
    if (this.reactiveForm.form.controls['steps'] == null) {
      this.reactiveForm.form.addControl('steps', new FormControl());
    }
    if (this.reactiveForm.form.controls['locked'] == null) {
      this.reactiveForm.form.addControl('locked', new FormControl());
    }
    if (this.reactiveForm.form.controls['step_id'] == null) {
      this.reactiveForm.form.addControl('step_id', new FormControl());
    }
    if (this.parentId > 0) {
      this.loading = true;
      this.itemService.getUrl(this.parentName + '/' + this.parentId + '/' + this.historicName + '?filter[include][step]=state&filter[where][active]=true')
        .subscribe(
        (items) => {
          for (let i = 0; i <= items.length - 1; i++) {
            if (parseInt(items[i].step.index) > this.lastIndex) if (items[i].valid) this.lastIndex = parseInt(items[i].step.index);
            this.stepList.push({ id: items[i].id, step_id: items[i].step.id, code: items[i].step.code, name: items[i].step.name, glyph: items[i].step.glyph, valid: items[i].valid, class: items[i].step.class, index: items[i].step.index });
          }
          if (this.stepList.length == 0) {
            this.init();
          } else {
            this.selectedStep = this.stepList[this.stepList.length - 1];
            this.reactiveForm.form.controls['steps'].patchValue(this.stepList);
          }
          this.loading = false;
        });
    } else {
      this.init();
    }
  }

  init() {
    this.loading = true;
    this.itemService.getUrl('steps' + '?filter[include]=state&filter[where][active]=true&filter[where][dbform_id]=' + this.dbform_id + '&filter[where][index]=1')
      .subscribe(
      (items) => {
        for (let i = 0; i <= items.length - 1; i++) {
          this.stepList.push({ step_id: items[i].id, code: items[i].code, name: items[i].name, glyph: items[i].glyph, valid: false, class: items[i].class, index: items[i].index });
          this.reactiveForm.form.controls['steps'].patchValue(this.stepList);
          this.reactiveForm.form.controls['step_id'].patchValue(items[i].id);
          this.reactiveForm.form.controls['locked'].patchValue(items[i].state.lock);
          this.lastIndex = 0;
        }
        if (this.stepList.length > 0) {
          this.selectedStep = this.stepList[this.stepList.length - 1];
        } else {
          this.selectedStep = null;
        }
        this.loading = false;
      });
      /*this.reactiveForm.onValidation = function() {
        this.reactiveForm.onValidation();
        if (this.stepList.length == 0) {
          this.selectedStep = this.stepList[this.stepList.length - 1];
          this.lastIndex = parseInt(this.selectedStep.index);
        }
      };*/
  }

  close(items: any) {
    this.addItem(items);
  }

  addItem(items: any) {
    if (items) {
      for (let i = 0; i <= items.length - 1; i++) {
        let valid: boolean = true;
        if (this.isSole) {
          for (let j = 0; j <= this.stepList.length - 1; j++) {
            if (this.stepList[j].step_id == items[i].id) {
              if (parseInt(items[i].index) > 0) {
                valid = false;
                break;
              }
            }
          }
        }
        if (valid) {
          this.itemService.getUrl('steps/' + items[i].id + '?filter[include]=state')
            .subscribe(
            (step: any) => {
              this.stepList.push({ id: 0, step_id: step.id, code: step.code, name: step.name, valid: false, glyph: step.glyph, class: step.class, index: items[i].index });
              this.reactiveForm.form.controls['step_id'].patchValue(step.id);
              this.reactiveForm.form.controls['locked'].patchValue(step.state.lock);
              this.reactiveForm.form.controls['steps'].patchValue(this.stepList); //if (items[i].index > this.lastIndex) this.lastIndex = items[i].index;
              this.selectedStep = this.stepList[this.stepList.length - 1];
            });
        }
      }
    }
  }

  openModalList() {
    this.genericlistService.restName = 'steps';
    this.genericlistService.title = 'Steps';
    this.genericlistService.href = 'steps';
    this.genericlistService.filter = [{ fieldName: 'dbform_id', value: this.dbform_id }];
    this.genericlistService.listFilter = '';
    this.genericlistService.infinite = true;
    this.genericlistService.templateNameRecord = 'Step';
    this.genericlistService.close = (id: any) => {
      this.close(id);
    }
    this.genericlistService.displayed = true;
  }

  next() {
    this.itemService.getUrl('steps?filter[where][dbform_id]=' + this.dbform_id + '&filter[where][index]=' + (this.lastIndex + 1))
      .subscribe(
      (steps) => {
        if (steps && (steps.length > 0)) {
          this.addItem(steps);
        }
      });
  }

  valid() {
    if (this.selectedStep) {
      this.reactiveForm.onValidation();
      if (this.reactiveForm.form.valid) {
        this.selectedStep.valid = true;
        if (this.selectedStep.index > 0) {
          this.lastIndex = parseInt(this.selectedStep.index);
        }
        this.next();
      } else {
        toastr.error('Vous devez renseigner toutes les informations', 'Erreur');
      }
    }
  }

  selectStep(step: any, i: number) {
    let index: number = 0;
    if (step.index && step.valid) {
      index = step.index;
    } else {
      for (let i = 0; i <= this.stepList.length - 1; i++) {
        if ((parseInt(this.stepList[i].index) > index) && this.stepList[i].valid) index = parseInt(this.stepList[i].index);
      }
    }
    this.lastIndex = index;
    this.selectedStep = step;
  }

  deleteStep(step: any) {
    const index: number = this.stepList.indexOf(step, 0);
    if (index > -1) {
      this.stepList.splice(index, 1);
      let lastIndex: number = 0;
      for (let i = 0; i <= this.stepList.length - 1; i++) {
        if (parseInt(this.stepList[i].index) > lastIndex) if (this.stepList[i].valid) lastIndex = parseInt(this.stepList[i].index);
      }
      this.lastIndex = lastIndex;
      this.reactiveForm.form.controls['steps'].patchValue(this.stepList);
      this.selectedStep = null;
    }
  }

  openItem(itemId: number) {
    if (itemId == 0) { return; }
    const parameters = {
      modal: true,
      close: (id: any) => {
        this.close(id);
      },
      options: {},
      id: itemId
    };
  }
}
